import { DirectionEnum } from "@/models/enums";
import { useBookingSummaryStore } from "@/store/basket";
import { useBookingStore } from "@/store/booking";
import { useCharityStore } from "@/store/charity";
import { useInsuranceStore } from "@/store/insurance";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { debounce } from "vue-composable";
import useCalculatePrice from "./useCalculatePrice";

const useCalculatePriceEffect = () => {
    const { calculate } = useCalculatePrice();
    const bookingSummary = useBookingSummaryStore();
    const bookingStore = useBookingStore();
    const charityStore = useCharityStore();
    const insuranceStore = useInsuranceStore();

    const debouncedCalculate = debounce(() => {
        bookingSummary.setLoading(true);
        calculate().finally(() => {
            bookingSummary.setLoading(false);
        });
    }, 400);

    const hasSelectedDeparture = () => {
        return bookingStore.getDeparture(DirectionEnum.Outward).id || bookingStore.getDeparture(DirectionEnum.Return).id;
    }

    const calculateProperties = computed(() => {
        const resources = [DirectionEnum.Outward, DirectionEnum.Return].map(d => bookingStore.getResources(d).length);
        const departures = [DirectionEnum.Outward, DirectionEnum.Return].map(d => bookingStore.getDeparture(d));
        const ticketTypes = [DirectionEnum.Outward, DirectionEnum.Return].map(d => bookingStore.getDeparture(d).ticketType);
        const charity = charityStore.getResources.length;
        const insurances = insuranceStore.getPassengers.length;

        return [resources, departures, charity, insurances, ticketTypes];
    })

    const unsubscribe = ref<any[]>([]);
    onMounted(() => {
        unsubscribe.value.push(watch(calculateProperties, () => {
            if (hasSelectedDeparture()) {
                bookingSummary.setLoading(true);
                debouncedCalculate();
            }
        }, { immediate: true }));
    });

    onBeforeUnmount(() => {
        unsubscribe.value.forEach(v => v());
    })

    return { hasSelectedDeparture, debouncedCalculate }
}

export default useCalculatePriceEffect;